import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Box, useTheme } from '@hermes/web-components'

const SellerListingSkeleton = ({ isHighlighted }: { isHighlighted: boolean }) => {
  const theme = useTheme()

  return (
    <Box
      style={{
        borderRadius: '12px',
        backgroundColor: isHighlighted ? theme.palette.neutral[100] : 'none'
      }}
    >
      {isHighlighted && (
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Skeleton width="150px" height="28px" borderRadius="12px 0" />
          <Skeleton width="115px" height="12px" style={{ marginRight: '12px' }} />
        </Box>
      )}

      <Box style={{ padding: isHighlighted ? '16px 12px 12px 12px' : 'none' }}>
        <Box display="flex" justifyContent="space-between" m="0">
          <Box display="flex">
            <Skeleton width="40px" height="40px" circle={true} />

            <Box display="flex" flexDirection="column" ml="8px">
              <Skeleton width="120px" height="16px" style={{ marginTop: '5px' }} />
              <Skeleton width="110px" height="12px" />
            </Box>
          </Box>

          <Box>
            <Skeleton width="100px" height="32px" style={{ borderRadius: '50px' }} />
            <Skeleton width="100px" height="10px" />
          </Box>
        </Box>

        <Box ml="50px">
          <Skeleton width="150px" height="12px" />
          <Box display="flex" height="99px" overflow="hidden" flexWrap="wrap" gap="8px">
            {Array(8)
              .fill(1)
              .map((val, i) => (
                <Skeleton width="60px" height="99px" key={i} />
              ))}
          </Box>
          <Skeleton width="30px" height="14px" style={{ margin: '5px 0px' }} />
        </Box>
      </Box>
    </Box>
  )
}
export default SellerListingSkeleton
